import { Form as _Form } from "@byte-design/ui/es/components/form";
import { CheckGroup as _CheckGroup } from "@byte-design/ui/es/components/check-group";
export var FieldCheckGroup = _Form.withField(_CheckGroup, [], {
  displayName: 'FieldCheckGroup',
  useInputRef: false,
  useDomRef: false
});
FieldCheckGroup.Button = _CheckGroup.Button;
FieldCheckGroup.Checkbox = _CheckGroup.Checkbox;
FieldCheckGroup.FreeButton = _CheckGroup.FreeButton;
FieldCheckGroup.Tag = _CheckGroup.Tag;
FieldCheckGroup.Filled = _CheckGroup.Filled;